export enum VersionState {
  DELETED = 'DELETED',
  IN_RECYCLE_BIN = 'IN_RECYCLE_BIN',
  EXISTS = 'EXISTS',
}
export interface ItemVersionInfo {
  id: string;
  versionCreatedOn: string;
  versionState: VersionState;
  name: string | undefined;
}
